import Link from 'next/link';
import { ArrowUpRight } from 'lucide-react';
import { MarketingBrand } from '@/components/marketing/MarketingBrand';

const groups = [
  {
    title: 'Product',
    links: [
      ['Free tools', '/tools'],
      ['Pricing', '/pricing'],
      ['Features', '/features'],
      ['Blog', '/blogs'],
      ['Changelog', '/changelog'],
      ['FAQs', '/FAQs'],
      ['Documentation', 'https://plotsalot-docs.docsalot.dev/introduction'],
      ['Feedback', 'https://plotsalot.featurebase.app/'],
      ['Roadmap', 'https://plotsalot.featurebase.app/roadmap'],
      ['Status', 'https://stats.uptimerobot.com/9jIHmTIesr'],
    ],
  },
  {
    title: 'Make a chart',
    links: [
      ['AI chart generator', '/tools/ai-chart-generator'],
      ['Bar chart generator', '/tools/bar-chart-generator'],
      ['Line graph generator', '/tools/line-graph-generator'],
      ['Pie chart generator', '/tools/pie-chart-generator'],
      ['CSV to chart', '/tools/csv-to-chart'],
      ['CSV editor', '/tools/csv-editor'],
      ['JSON to CSV', '/tools/json-to-csv'],
      ['CSV to JSON', '/tools/csv-to-json'],
      ['Data type validator', '/tools/data-type-validator'],
      ['JSON formatter', '/tools/json-formatter'],
      ['Chart recommender', '/tools/chart-recommender'],
    ],
  },
  {
    title: 'Compare',
    links: [
      ['PlotsAlot vs Julius', '/compare/julius'],
      ['PlotsAlot vs Graphy', '/compare/graphy'],
      ['PlotsAlot vs ChatGPT', '/compare/chatgpt'],
      ['PlotsAlot vs Power BI', '/compare/powerbi'],
      ['ChatGPT vs Claude', '/versus/chatgpt-vs-claude'],
      ['Julius vs Hex', '/versus/julius-vs-hex'],
      ['Graphy vs Gamma', '/versus/graphy-vs-gamma'],
    ],
  },
  {
    title: 'Say hello',
    links: [
      ['Contact', 'mailto:faizank@slashml.com'],
      ['Support', 'mailto:support@slashml.com'],
      ['LinkedIn', 'https://linkedin.com/company/slashml'],
      ['Discord', 'https://discord.gg/Dp6EpTv4BU'],
      ['For AI readers', '/llm.txt'],
    ],
  },
];

export function Footer() {
  return (
    <footer className="marketing-theme marketing-footer">
      <div className="marketing-container">
        <div className="marketing-footer-lead">
          <div>
            <p className="marketing-eyebrow">FROM DATA TO SOMETHING WORTH SHARING</p>
            <h2>
              Make your next chart
              <br />
              your best one.
            </h2>
          </div>
          <Link href="/chat" className="marketing-button">
            Start for free <ArrowUpRight size={17} />
          </Link>
        </div>
        <div className="marketing-footer-grid">
          {groups.map(group => (
            <div key={group.title}>
              <h3>{group.title}</h3>
              <ul>
                {group.links.map(([label, href]) => (
                  <li key={href}>
                    <Link href={href}>{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="marketing-footer-bottom">
          <MarketingBrand />
          <span>&copy; {new Date().getFullYear()} SlashML Corp.</span>
          <div>
            <Link href="/privacy-policy">Privacy</Link>
            <Link href="/terms">Terms</Link>
            <Link href="/gdpr-compliance">GDPR</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
